import React from 'react';
// import MetaTags from 'react-meta-tags';
import {Helmet} from "react-helmet";



const getTitle = title => {
  if (title) {
    return `${title} - MiDrive Transfer`;
  } else {
    return 'MiDrive Transfer';
  }
}

const getImage = () => {
  return 'https://oreklabsassets.s3.amazonaws.com/meta-image.png';
}

const getDescription = (description, title) => {
  if (description) {
    return description;
  } else {
    return `MiDrive Transfer ${title}`;
  }
}

const getUrl = () => {
  return window.location.href;
}

const CustomMetaTags = ({ title, description }) => {
  const imageUrl = getImage();
  const _description = getDescription(description, title)
  const _title = getTitle(title);
  const url = getUrl();

  return (
    <Helmet>
      <title>{_title}</title>
      <meta name="title" content={_title} />
      <meta name="image" content={imageUrl} />
      <meta name="description" content={_description} />
      <meta name="keywords" content='midrive,pcloud,wetransfer,easyupload' />
      <meta name="url" content={url} />
      <meta property="og:title" content={_description} />
      <meta property="og:image" content={imageUrl} />
      <meta property="og:title" content={_title} />
      <meta property="og:url" content={url} />
      <meta name="twitter:card" content="summary_large_image" />
    </Helmet>
  )
}

export default CustomMetaTags;